// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__29Hyw","range":"MonthRangeSwitch_range__wX1hA","disabled":"MonthRangeSwitch_disabled__24D68"};